import Button from "components/Button/index";

import "./byos.scss";
import SelectDropDown from "components/SelectDropDown/SelectDropDown";
import { useState, useEffect } from "react";
import { BYOS as byos } from "@induz/sdk";
import Azure from "./azure/azure";
import Minio from "./minio/minio";
import AWS from "./aws/aws";
import StatusTable from "./Status/status";
import { useToast } from "components/Toaster/index";
import tick from "assets/images/authenticate/Frame.svg";
import { useNavigate } from "react-router-dom";
import MigrateMessage from "containers/MigrateMessage/migrateMessage";
import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";
import useTheme from "hooks/observer";
const BYOS = (
    {
        background = false,
        updateOn = false,
        setByosOn,
        setUpdateOn,
        onClose
    }
) => {

    // verified -> after clicking verify, show a diffeent screen
    // continued -> if verification is successful, enable set option
    // status -> if verification fails, enable status to show status of differnet stages
    // message -> after set is clicked, only show message

    const [selectedStorage, setSelectedStorage] = useState("");
    const [azureConnectionString, setAzureConnectionString] = useState("");
    const [azureAccountName, setAzureAccountName] = useState("");
    const [azureAccountKey, setAzureAccountKey] = useState("");
    const [minioEndpoint, setMinioEndpoint] = useState("");
    const [minioAccessKey, setMinioAccessKey] = useState("");
    const [minioSecretKey, setMinioSecretKey] = useState("");
    const [ssl, setSsl] = useState(false);
    const [verified, setVerified] = useState(false);
    const [continued, setContinued] = useState(false);
    const [status, setStatus] = useState([]);
    const [message, setMessage] = useState(false);
    const storages = [
        "Azure",
        "AWS",
        "MinIO",
    ];
    const showToast = useToast();
    const theme = useTheme();
    
    const handleClose = () => {
        try {
            if (onClose && typeof onClose === "function") {
                onClose();
            } else {
                if (setByosOn && typeof setByosOn === "function") {
                    setByosOn(false);
                }
                if (setUpdateOn && typeof setUpdateOn === "function") {
                    setUpdateOn(false);
                }
            }
        } catch (error) {
            console.error("Error closing BYOS modal:", error);
            // Silently handle the error to prevent app crash
        }
    };
    
    const handleVerify = async () => {
        let details;
        switch (selectedStorage) {
            case "":
                showToast("No storage selescted", "error");
                return;
            case "Azure":
                details = {
                    accountName: azureAccountName,
                    accountKey: azureAccountKey,
                    connectionString: azureConnectionString
                };
                break;
            case "MinIO":
                details = {
                    endpoint: minioEndpoint,
                    accessKey: minioAccessKey,
                    secretKey: minioSecretKey,
                    ssl: String(ssl)
                };
                break;
        }
        // console.log("details", details);
        try {
            const res = await byos.verifyBYOSCred(
                selectedStorage,
                details
            );
            setStatus(res);
            if (res.length == 0) {
                setContinued(true);
            }
            setVerified(true);
            // console.log(res);
        } catch (error) {
            // if error handle it
        }

    };

    const handleEdit = () => {
        setVerified(false);
        setContinued(false);
    };
    useEffect(() => {
        (async () => {
            if (updateOn) {
                try {
                    const storageDetails = await byos.getStorageCreds();
                    if (storageDetails.minio != null) {
                        setSelectedStorage("MinIO");
                    } else if (storageDetails.azureBlob != null) {
                        setSelectedStorage("Azure");
                        setAzureAccountName(storageDetails.azureBlob.accountName);
                    } else if (storageDetails.aws != null) {
                        setSelectedStorage("AWS");
                    } else {
                        showToast("Corrupted details are sent from server. Please contact support", "error");
                        setByosOn(false);
                        setUpdateOn(false);
                    }
                } catch (error) {
                    setByosOn(false);
                    setUpdateOn(false);
                    showToast(error.message, "error");
                    console.error(error);
                }
            }
        })();
    }, []);

    const handleUpdate = async () => {
        let details;
        switch (selectedStorage) {
            case "":
                showToast("No storage selescted", "error");
                return;
            case "Azure":
                details = {
                    accountName: azureAccountName,
                    accountKey: azureAccountKey,
                    connectionString: azureConnectionString
                };
                break;
            case "MinIO":
                details = {
                    endpoint: minioEndpoint,
                    accessKey: minioAccessKey,
                    secretKey: minioSecretKey,
                    ssl: String(ssl)
                };
                break;
        }
        // console.log("details", details);
        try {
            await byos.updateCredentials(selectedStorage, details);
            // console.log("Updating details", details);
            showToast("New Credentials are set", "success");
            setByosOn(false);
            setUpdateOn(false);
        } catch (error) {
            // if error handle it
            showToast(error.message, "error");
            console.error(error);
        }
    };


    const handleSet = async () => {
        // console.log("selected storage", selectedStorage);
        let details;
        switch (selectedStorage) {
            case "":
                return;
            case "Azure":

                details = {
                    accountName: azureAccountName,
                    accountKey: azureAccountKey,
                    connectionString: azureConnectionString
                };
                break;

            case "MinIO":
                details = {
                    endpoint: minioEndpoint,
                    accessKey: minioAccessKey,
                    secretKey: minioSecretKey,
                    ssl: String(ssl)
                };
                break;

            case "AWS":
                details = {

                };
                showToast("Coming Soon");


        }
        try {

            // console.log("details", details);
            const res = await byos.setBYOSCred(
                selectedStorage,
                details
            );
            if (res != "") {
                // console.log("Waiting for backend to complete task.");
                showToast(res);
            }
            setMessage(true);
            showToast(res);
        } catch (error) {
            setVerified(false);
            setContinued(false);
            setByosOn(false);
            showToast(error.message, "error");
        }
        return;
    };

    const handlChangeStorage = (value) => {
        setSelectedStorage(value);
        setAzureConnectionString("");
        setAzureAccountName("");
        setAzureAccountKey("");
        setMinioEndpoint("");
        setMinioAccessKey("");
        setMinioSecretKey("");
    };
    return (
        <>
            <section
                className="byos"
                style={{
                    backgroundImage: background && "none",
                    backgroundColor: background && "transparent",
                    padding: background && "0"
                }}
            >
                <div className="container byosContainer">
                    <div className="byosTitle">
                        <h1 className="title">Bring Your Own Storage</h1>
                        <div className="closeIcon" onClick={handleClose}>
                            <GetActionIcon
                                type="cross"
                                color={theme === "light" ? "#7D708A" : "#BDB8C2"}
                            />
                        </div>
                    </div>


                    {(continued || !verified) && !message && <div className="byosBox">
                        <SelectDropDown
                            label="Type Of Storage"
                            star="*"
                            placeholder="Storage"
                            selectedCountry={selectedStorage}
                            data={storages}
                            onSelectCountry={(value) => handlChangeStorage(value)}
                            width={"90%"}
                            disabled={updateOn}
                        />
                        {selectedStorage === "Azure" && <Azure
                            azureConnectionString={azureConnectionString}
                            setAzureConnectionString={setAzureConnectionString}
                            azureAccountKey={azureAccountKey}
                            setAzureAccountKey={setAzureAccountKey}
                            azureAccountName={azureAccountName}
                            setAzureAccountName={updateOn ? "" : setAzureAccountName}
                            setVerified={setVerified}
                            setContinued={setContinued}
                        />
                        }
                        {selectedStorage == "MinIO" && <Minio
                            minioEndpoint={minioEndpoint}
                            setMinioEndpoint={setMinioEndpoint}
                            minioAccessKey={minioAccessKey}
                            setMinioAccessKey={setMinioAccessKey}
                            minioSecretKey={minioSecretKey}
                            setMinioSecretkey={setMinioSecretKey}
                            ssl={ssl}
                            setSsl={setSsl}
                            setVerified={setVerified}
                            setContinued={setContinued}
                        />
                        }
                        {selectedStorage == "AWS" && <AWS />}


                    </div>}
                    {verified && !continued && !message &&
                        <StatusTable
                            status={status}
                        />
                    }
                    {message && <MigrateMessage
                        Heading="🔄 Please wait while we process your request"
                        SubHeading="The status will be sent to your email shortly."
                        Content="Refresh the page and avoid taking any further action while this is in progress."
                        Note="Note: Dont remove your storage until the migration succeed."
                        loading={false}
                    />
                    }


                    <div className="footerEnd">
                        {updateOn == false && <div>
                            {
                                (verified && continued) && !message &&
                                <p className="byosVerified">
                                    <img src={tick} alt="Verified" className="icon" /> Verified
                                </p>
                            }
                            {!message && <Button
                                type="violet"
                                title={!verified ? "Verify" : !continued ? "Edit" : "Verified"}
                                onClick={verified ? handleEdit : handleVerify}
                                disabled={
                                    continued ||
                                    (
                                        !selectedStorage ||
                                        !(
                                            (
                                                azureConnectionString &&
                                                azureAccountKey &&
                                                azureAccountName
                                            ) ||
                                            (
                                                minioAccessKey &&
                                                minioSecretKey &&
                                                minioEndpoint
                                            )
                                        )
                                    ) ||
                                    selectedStorage == "AWS"
                                }
                            />}
                            {!(verified && !continued) && !message && <Button
                                type="violet"
                                title={"Set"}
                                onClick={handleSet}
                                disabled={!(verified && continued)}
                            />}
                        </div>}
                        {updateOn && <Button
                            type="violet"
                            title={"Update"}
                            onClick={handleUpdate}
                            disabled={
                                continued ||
                                (
                                    !selectedStorage ||
                                    !(
                                        (
                                            azureConnectionString &&
                                            azureAccountKey &&
                                            azureAccountName
                                        ) ||
                                        (
                                            minioAccessKey &&
                                            minioSecretKey &&
                                            minioEndpoint
                                        )
                                    )
                                )
                            }
                        />
                        }
                    </div>
                </div>
            </section>
        </>
    );
};

export default BYOS;